<template>
  <div :class="componentClassName">
    <a-page-heading>営業時間設定</a-page-heading>

    <m-section variant="fullpage">
      <m-action-card
        :title="`${numberName}（${telNumber}）の営業時間`"
        icon="clock"
        :narrow-body="true"
        :help="true"
        @help:click="helpDialogVisible = true"
      >
        <form ref="form" class="t-setting-business-hours-edit-business-hours__form" @submit.prevent="handleFormSubmit">
          <div class="t-setting-business-hours-edit-business-hours__fields">
            <o-business-hour-setting-list v-model="currentPeriodList" />
            <m-form-action-buttons>
              <a-button id="store" variant="block" color="primary" :disabled="savaButtonDisable" submit="submit">
                保存</a-button
              >
              <a-button id="cancel" variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingBusinessHoursEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
      <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingBusinessHoursEdit_helpModal"
      v-model:visible="helpDialogVisible"
      class="o-modal-help-dialog"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      @close="handleCloseHelpDialog"
    >
      <template #title>営業時間とは</template>
      <a-text> 外線着信する時間を営業時間として設定します。</a-text>
      <a-text>営業時間は15分単位での設定が可能です。</a-text>
      <a-text>営業時間は複数の外線番号をお持ちの場合、すべての番号に適用されます。</a-text>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import OBusinessHourSettingList from '@/components/organisms/business-hour-setting-list';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT } from '@/libs/constants';

// For Trial
import { utils } from '@/common/utils.js';

export default {
  name: 't-setting-business-hours-edit-business-hours',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    OBusinessHourSettingList,
    MFormActionButtons,
    AButton,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    periodList: {
      type: Array,
      default: new Array(0),
    },
    companyID: {
      type: String,
      default: '',
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      currentPeriodList: [],
      selectedCompanyID: '',
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      savaButtonDisable: false,
      helpDialogVisible: false,
      telNumber: '',
      numberName: '',
      saveSuccessFlag: false, // 保存成功フラグ
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-business-hours-edit-business-hours');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    periodList: {
      handler(val) {
        this.currentPeriodList = val;
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    }
    this.telNumber = this.$route.params.telNumber;
    this.numberName = this.$route.params.numberName;
    if (!this.telNumber || !this.numberName) {
      this.$router.push({ name: 'ServiceConditionList' });
      return;
    }
    this.handlerGetBusinessHoursList();
  },
  mounted() {
    this.currentPeriodList = this.periodList;
    if (utils.chkTrialCompanyID(this.companyID) || utils.chkTrialCompanyID(this.selectedCompanyID)) {
      this.savaButtonDisable = true;
      this.showInfoModal(messageContent.notifyTrialUserCanNotSaveBusinessHours('営業時間設定'));
    }
  },
  methods: {
    handlerGetBusinessHoursList: function () {
      this.postRequest('/servicecondition/getbusinesshours', {
        companyID: this.selectedCompanyID,
        telNumber: this.telNumber,
      })
        .then(e => {
          this.currentPeriodList = e.currentPeriodList;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('営業時間設定の取得'));
        });
    },
    handleFormSubmit(e) {
      e.preventDefault();
      const payload = cloneDeep(this.currentPeriodList);
      if (this.currentPeriodList.length !== 0) {
        this.handleSaveClick(payload);
      }
    },
    handleSaveClick() {
      for (let i = 0; i < 7; i++) {
        if (this.currentPeriodList[i].periods.length !== 0 && this.currentPeriodList[i].is24hours) {
          this.showErrorModal(messageContent.businessHoursConflictSetting);
          return;
        }
        if (this.currentPeriodList[i].periods.length === 0 && this.currentPeriodList[i].active) {
          this.showErrorModal(messageContent.requireBusinessHours);
          return;
        }
      }
      const formDataTmp = {
        companyID: this.selectedCompanyID,
        telNumber: this.telNumber,
        currentPeriodList: this.currentPeriodList,
      };
      this.setLoading(true);
      this.postRequest('/servicecondition/updatebusinesshours', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            this.showUpdateInfoModal(messageContent.businessHoursSettingCompleted);
          } else if (e.status === 'duplicate') {
            this.showErrorModal(e.message);
          } else if (e.status === 'exceed') {
            this.showErrorModal(e.message);
          } else if (e.status === 'incorrect') {
            this.showErrorModal(e.message);
          } else if (e.status === 'nullHour') {
            this.showErrorModal(e.message);
          } else {
            this.showErrorModal(messageContent.updateSettingError);
          }
          this.setLoading(false);
        })
        .catch(e => {
          if (e === 404) return this.showErrorModal(messageContent.noOperationPermission);
          this.setLoading(false);
          return this.showErrorModal(messageContent.updateSettingError);
        });
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({
          path: '/service-condition',
          query: { companyID: this.$route.query.companyID, telNumber: this.telNumber },
        });
      } else {
        this.$router.push({
          path: '/service-condition',
          query: { telNumber: this.telNumber },
        });
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.saveSuccessFlag) {
        // 正常保存の場合、営業時間設定画面に遷移
        this.handleCancelClick();
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showUpdateInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = true;
    },
  },
};
</script>
